<!--
 * @Author: wuyanfeiying
 * @LastEditors: wuyanfeiying
 * @Description: 一维分割图 弹窗
-->
<template>
  <el-drawer
    size="50%"
    :append-to-body="true"
    :visible.sync="drawer"
    :direction="direction"
    @closed="handleClose"
  >
    <template #title>
      <div>
        <div style="font-size: 22px;font-weight: 600;margin-bottom: 10px;">一维分割图</div>
        <!-- 选择天数 -->
        往前&nbsp;<el-input-number v-model="limitDay" size="mini" :min="0" :max="999" :step="1" :controls="true" controls-position="both" @change="onChangeByLimitDayNum">
        </el-input-number> 天
        往后&nbsp;<el-input-number v-model="limitDayNum" size="mini" :min="1" :max="999" :step="1" :controls="true" controls-position="both" @change="onChangeByLimitDay">
        </el-input-number> 天
        <!-- 导出按钮 -->
        <el-link style="margin-left: 20px;" type="primary"  @click="exportAllCharts">导出当前所有图</el-link>
      </div>
    </template>
    <div class="merge-echart-title"><span v-if="limitDay">往前<span class="num">&nbsp;{{ limitDay }}天&nbsp;，</span></span>往后<span class="num">&nbsp;{{ limitDayNum }}天&nbsp;</span>按照日期分割汇总图 &emsp;<el-link type="primary" size="medium" @click="mergeByZero" >{{isMergeByZero?'取消对齐':'对齐'}}</el-link>
     </div>
    <FactorEchart
            v-if="showMergeByLimitDay"
            class="factor-echart-item"
            ref="mergeByLimitDayEchart"
            :options="mergeByLimitDayOptions"
          />
    <template v-if="echartOptions.length">
      <div class="factor-echart-content">
        <template v-for="(options, index) in echartOptions">
          <FactorEchart
            v-if="options.show"
            class="factor-echart-item"
            :key="index"
            ref="echart"
            :options="options"
          />
          <div
            :key="'empty-'+index"
            v-else
            v-loading="options.show"
            :element-loading-text="loadingText"
            style="height: 400px; width: 100%"
          ></div>
        </template>

      </div>

    </template>
  </el-drawer>
</template>

<script>
import FactorEchart from './FactorEchart.vue'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'FactorLineDialogByOne',

  components: {
    FactorEchart
  },

  props: {
    show: { type: Boolean, default: false },
    dialogData: { type: Array, default: () => [] },
    dialogForwardData: { type: Array, default: () => [] },
    limit: { type: Number, default: 60 }
  },

  data () {
    return {
      drawer: this.show,
      direction: 'rtl',
      loadingText: '图表正在生成中，请稍等...',
      echartOptions: [],
      // 往前多少天
      limitDay: 0,
      // 往后多少天
      limitDayNum: this.limit,
      showMergeByLimitDay: false,
      isMergeByZero: false, // 是否归0合并
      mergeByLimitDayOptions: {}, // 合并图表数据
      orgMergeByLimitDayOptions: {}, // 缓存原始的合并图表数据
      backwardData: [], // 缓存往后的数据
      forwardData: [] // 缓存往前的数据
    }
  },

  watch: {
    // 往后多少天改变后的图表数据
    dialogData: {
      deep: true,
      immediate: true,
      handler (value) {
        this.echartOptions = cloneDeep(value)
        this.showMergeByLimitDay = true
        this.backwardData = cloneDeep(value)
        this.handleEchartData(cloneDeep(this.dialogForwardData), cloneDeep(value))
      }
    },

    // 往前多少天改变后的图表数据
    dialogForwardData: {
      deep: true,
      immediate: true,
      handler (value) {
        // 将往前的图表 和 往后的图表数据 合并处理
        // X轴会变长
        if (value && value.length && this.dialogData && this.dialogData.length) {
          this.forwardData = cloneDeep(value)
          this.handleEchartData(value, cloneDeep(this.dialogData))
        }
      }
    }
  },

  methods: {
    // 导出所有图表
    exportAllCharts () {
      // 获取所有 FactorEchart 组件的实例
      const echartInstances = this.$refs.echart
      const mergeByLimitDayEchartInstances = this.$refs.mergeByLimitDayEchart

      // 定义一个函数来导出图表为图片
      const exportChart = (chartInstance) => {
        if (chartInstance) {
          // 导出图片
          chartInstance.exportImage()
        }
      }

      // 遍历并导出所有的 echart 实例
      echartInstances.forEach((instance) => {
        exportChart(instance)
      })

      // 导出 mergeByLimitDayEchart 实例
      exportChart(mergeByLimitDayEchartInstances)
    },

    handleClose () {
      this.drawer = false
      this.$emit('close')
    },

    // 往后X天数变化
    onChangeByLimitDay (value) {
      if (value === 0) {
        this.echartOptions = cloneDeep(this.forwardData)
        this.showMergeByLimitDay = true
        this.mergeByLimitDay()
        return
      }
      this.$emit('update:limit', value)
      this.$emit('change', value)
    },

    // 往前X天数变化
    onChangeByLimitDayNum (value) {
      if (value === 0) {
        this.echartOptions = cloneDeep(this.backwardData)
        this.showMergeByLimitDay = true
        this.mergeByLimitDay()
        return
      }
      this.$emit('update:limitDay', value)
      this.$emit('changeByLimitDay', value)
    },

    // 按照往后X天数合并
    mergeByLimitDay (data = null) {
      // 根据当前的图表数据集合，X轴为时间段（比如60就是0-59），data进行合并
      if (this.echartOptions.length) {
        const echartOptions = data || cloneDeep(this.backwardData)
        const decimalPlaces = 4
        const mulNum = 1
        const saveImgTitle = `按照往后${this.limitDayNum}天,往前${this.limitDay}天,合并后的分割图`
        let seriesData = []
        let xAxisData = []
        let yAxisDataTitle = '数值'

        // 往后X天, 正着递增
        for (let index = 0; index <= this.limitDayNum; index++) {
          xAxisData.push(index)
        }

        // 往前X天, 反着递减
        // limitDay 2
        for (let i = 1; i <= this.limitDay; i++) {
          xAxisData.unshift(-i)
        }

        if (!echartOptions.length) return

        for (let index = 0; index < echartOptions.length; index++) {
          const element = echartOptions[index]
          if (element.seriesData.length) {
            let item = cloneDeep(element.seriesData[0])
            delete item.itemStyle
            seriesData.push(item)
          }
        }

        const grid = {
          top: `30%`, // 增加顶部空间，为图例腾出位置
          left: '12%', // 根据需要调整左侧空间
          right: '8%' // 根据需要调整右侧空间
          // bottom: '18%' // 根据需要调整底部空间
        }

        const legend = {
          left: '10%',
          // 其他图例设置
          textStyle: {
            fontSize: 12
          }
        }

        const tooltip = {
          trigger: 'axis', // 表示当鼠标悬停在坐标轴上时触发显示提示框
          feature: {
            restore: {
              show: true
            }
          },
          formatter: (params) => {
            let title = params[0].name === '0' ? '起点' : (+params[0].name < 0 ? `往前${Math.abs(params[0].name)}天` : `往后${+params[0].name}天`)
            let tooltipContent = `<div style="color: #b3292c;">${title}</div></div></div><div style="text-align: left;">` // 设置内容左对齐
            // 根据 params 中的数据自定义提示框的内容
            params.forEach((item) => {
              tooltipContent += item.seriesName + ' ' + item.marker + ' ' + item.value + '<br>'
            })
            tooltipContent += '</div>'
            return tooltipContent
          }
        }

        const toolbox = {
          feature: {
            saveAsImage: {
              show: true,
              name: saveImgTitle,
              type: 'jpeg',
              pixelRatio: 2,
              excludeComponents: ['toolbox']
            }
          }
        }

        const xAxis = {
          type: 'category',
          data: xAxisData,
          boundaryGap: false,
          splitLine: {
            show: true,
            interval: (index, value) => {
              // 当值为0时始终显示
              if (+value === 0) {
                return true
              }
              // 计算每份的间隔
              const interval = Math.ceil(xAxisData.length / 20)
              // 根据计算的间隔显示分割线
              return index % interval === 0
            }
          },
          // X轴的label设置
          axisLabel: {
            interval: (value, index) => {
              const num = +value
              if (num === 0 || index === xAxisData.length - 1) {
                return true
              }
              // 计算每份的间隔
              const interval = Math.ceil(xAxisData.length / 20)
              return index % interval === 0
            },
            formatter: (value, index) => {
              return +value === 0 ? '起点' : value
            },
            color: function (value, index) {
              return +value === 0 ? '#b3292c' : 'black'
            }

          }
        }

        this.mergeByLimitDayOptions = {
          decimalPlaces,
          mulNum,
          saveImgTitle,
          seriesData,
          xAxisData,
          yAxisDataTitle,
          grid,
          legend,
          tooltip,
          toolbox,
          xAxis
        }
        // 对于已经存在的图例, 进行隐藏操作
        this.orgMergeByLimitDayOptions = cloneDeep(this.mergeByLimitDayOptions)
        this.handleMergeByZero()
        this.showMergeByLimitDay = true
      }
    },

    // 图表数据处理（默认往后X天，如果点了往前X天，需要合并）
    // forwardData: 往前X天的图表数据
    // backwardData: 往后X天的图表数据
    handleEchartData (forwardData, backwardData) {
      let value = cloneDeep(backwardData)
      for (let index = 0; index < forwardData.length; index++) {
        const forward = forwardData[index]
        const backward = value[index]
        const { xAxisData, seriesData } = forward

        // 合并X轴数据
        backward.xAxisData.unshift(...xAxisData)
        // 合并data数据
        for (let j = 0; j < seriesData.length; j++) {
          backward.seriesData[j].data.unshift(...seriesData[j].data)
        }
      }

      this.echartOptions = value
      this.showMergeByLimitDay = true
      this.mergeByLimitDay(this.echartOptions)
    },

    // 对汇总图中 mergeByLimitDayOptions 的所有数据进行 归零操作
    // 每一条曲线图的数据 通过剪前值 进行操作
    mergeByZero () {
      this.isMergeByZero = !this.isMergeByZero
      this.handleMergeByZero()
    },

    handleMergeByZero () {
      if (!this.isMergeByZero) {
        this.mergeByLimitDayOptions = cloneDeep(this.orgMergeByLimitDayOptions)
        return
      }
      const options = cloneDeep(this.mergeByLimitDayOptions)
      if (!options || !options.seriesData) return
      // options.legend.selected = {}
      for (let index = 0; index < options.seriesData.length; index++) {
        const element = options.seriesData[index]
        const data = element.data
        if (!data || !Array.isArray(data)) return
        // options.legend.selected[element.name] = false
        // 每一个值等于当前值减掉上一个值，如果是第一个值，则减去当前的值
        for (let i = element.data.length - 1; i > 0; i--) {
          // 从后向前迭代，计算与前一元素的差值
          element.data[i] -= element.data[i - 1]
        }
        // 将第一个元素设为0
        if (element.data.length > 0) {
          element.data[0] = 0
        }
      }

      this.mergeByLimitDayOptions = options
    }
  }
}
</script>

<style scoped>
.factor-echart-content {
    width: 100%;
    box-sizing: border-box;
    padding: 0px 10px 40px;
}
.factor-echart-item {
    margin-bottom: 40px;
}
.merge-echart-title {
  text-align: center;
  margin-bottom: 20px;
}
.merge-echart-title .num {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/allPage/FactorLineDialogByOne.vue